import React, { useEffect, useState } from "react";
import PhoneIcon from "../../assets/phoneIcon.svg";
import MessageIcon from "../../assets/messageIcon.png";
import ProfileIcon from "../../assets/profileEdit.svg";
import Stephan from "../../assets/Stephan.png";
import Profile2 from "../../assets/profile2.jpg";

import { userAction } from "../../redux/auth";
import { useDispatch, useSelector } from "react-redux";
import one from "../../assets/icons/user.png";
import two from "../../assets/bg.svg";
import { change } from "../../redux/lang";
import customProtocolCheck from "custom-protocol-check";
import Description from "../../Components/Adons/Description";
import three from "../../assets/gold.svg";
import four from "../../assets/dimond.svg";
import five from "../../assets/bronze.svg";
import useChangeUserData from "../../customHooks/useChangeUserName";

import { Dropdown } from "antd";

const TestProfile = () => {
  const [userProfile, setuserProfile] = useState(null);
  const [username, setUserName] = useState("");
  const auth = useSelector((state) => state.user.value);
  const language = useSelector((state) => state.lang.language);
  const [changeProfile, setChangeProfile] = React.useState(false); // Initially set to false
  const dispatch = useDispatch();
  console.log(auth);
  const userLogout = () => {
    dispatch(userAction.logout());
  };
  const { changeUserNameOnline, usernames } = useChangeUserData(auth?.token);

  const changeUsers = (name) => {
    setUserName(name.target.value);
    console.log(username);
  };

  React.useEffect(() => {
    let authParser = auth?.userData;
    setuserProfile(authParser);
  }, []);

  const newDataIs = (link) => {
    customProtocolCheck(
      link,
      () => {
        console.log("Custom protocol not found.");
      },
      () => {
        console.log("Custom protocol found and opened the file successfully.");
      },
      5000
    );
  };

  let togleProfileName = () => {
    let user = auth?.value?.token;
    if (!user) {
      return;
    }
    changeUserNameOnline(user, username);
    setChangeProfile(!changeProfile); // Toggling the state for edit/save
  };

  useEffect(() => {
    if (auth?.phone) {
      changeUserNameOnline(auth.phone, username);
    }
    if (usernames !== "") {
      setUserName(usernames);
    }
  }, [changeProfile, usernames]);

  if (userProfile) {
    return (
      <div className=" bg-light-green h-screen flex pt-32 md:pt-0 items-center justify-center px-10 sm:px-0   overflow-hidden">
        <div className="  bg-white rounded-2xl  max-w-xl md:max-w-3xl lg:max-w-5xl sm:pt-36 pt-24  mx-auto   flex flex-col sm:flex-row gap-4 w-full  p-8 sm:p-10 relative text-light-green">
          {/* circle */}
          <div className="absolute  sm:-top-24 -top-12  sm:left-10 left-1/2 -translate-x-1/2  sm:translate-x-0 z-10">
            <div className=" sm:w-52 sm:h-52  w-24 h-24 shrink-0 relative  outline outline-2 outline-offset-4  outline-light-green  grow-0 rounded-full  flex text-red-900 items-center justify-center">
              <img
                src={one}
                alt="Profile"
                className="w-full h-full object-contain rounded-full"
              />

              <img
                src={ProfileIcon}
                className="absolute  hover:cursor-pointer bottom-0 w-6 h-6 right-1 sm:bottom-2 sm:right-3 sm:w-10 sm:h-10   rounded-full shadow-md"
                alt="Edit"
              />
            </div>
          </div>

          <div className=" w-full  flex flex-col gap-10  sm:gap-5 ">
            <div className=" sm:w-max w-full  flex flex-col gap-2   text-center px-4 justify-center pb-3  ">
              <a
                onClick={() => togleProfileName()}
                className="text-xs text-gray-500 text-center font-milkr"
              >
                {!changeProfile || !username
                  ? language?.changeUN || "change username" // Default fallback to string
                  : "save username"}
              </a>
              <div className="flex  text-white items-center justify-center  w-full  md:justify-start  ">
                <input
                  prefix="@kinet-"
                  onChange={(e) => changeUsers(e)}
                  value={username}
                  className=" bg-light-green text-center w-48"
                  placeholder="Gamer Name  "
                />
              </div>
            
            </div>
            <div className="grid gap-5 sm:border-none border-t py-5  px-4 sm:px-0 border-slate-300">
              <div className="grid grid-cols-[2rem_1fr] gap-2 font-gothaml items-center">
                <img src={PhoneIcon} className="w-6 h-6" />
                <p>{userProfile?.phone}</p>
              </div>
              <div className="grid grid-cols-[2rem_1fr] gap-2 font-gothaml items-center ">
                <img src={MessageIcon} className="w-6 h-6" />
                <p>Email not Set</p>
              </div>
            </div>
          </div>
          <div className=" w-full flex flex-col  space-y-8 sm:border-none border-t py-5 px-4 sm:px-0 sm:py-0 border-slate-300">
            <div className=" flex flex-col gap-3">
              <h3 className="  sm:text-lg font-gotham">Available Coins</h3>
              <p className="font-gothaml sm:text-base text-sm">No coins</p>
            </div>
            <div className="flex flex-col  gap-3">
              <h3 className="sm:text-lg font-gotham">My Store</h3>
              <p className=" font-gothaml sm:text-base text-sm">
                You have not purchased any games
              </p>
            </div>

            <div className="   font-gotham   w-full flex items-center md:justify-start justify-center  rounded-xl">
              <button
                onClick={() => userLogout()}
                className="  text-white bg-light-green rounded-xl px-3 py-2 w-52"
              >
                {language?.logout}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <h1 className=" h-screen items-center justify-center">
        <span>Loading...</span>
      </h1>
    );
  }
};

export default TestProfile;
